import { i18n as i18nFn, I18n as I18nReact } from "@lookiero/i18n-react";
import { EndpointFunction, fetchTranslations, translationEndpoints } from "@lookiero/sty-psp-i18n";
import { Tradename } from "@lookiero/sty-sp-tradename";

const DOMAIN = "LookAndLikeI18n";

const PREFIX = "look_and_like.";

enum I18nMessages {
  TITLE = "title",
  DESCRIPTION = "text",
  LIKE = "button.like",
  DISLIKE = "button.dislike",
  SUCCESS_TITLE = "success.title",
  SUCCESS_DESCRIPTION = "success.text",
  LAST_GAME_TITLE = "success.last_game.title",
  LAST_GAME_DESCRIPTION = "success.last_game.text",
  HOW_TO_TITLE = "howto.title",
  HOW_TO_PARAGRAPH_1 = "howto.paragraph_1",
  HOW_TO_PARAGRAPH_2 = "howto.paragraph_2",
}

const cache = new Map<Tradename, I18nReact>();

interface I18nFunctionArgs {
  readonly tradename: Tradename;
}

interface I18nFunction {
  (args: I18nFunctionArgs): I18nReact;
}

const i18n: I18nFunction = ({ tradename }) => {
  if (cache.has(tradename)) {
    return cache.get(tradename)!;
  }

  const translations: EndpointFunction[] = [
    (locale) =>
      translationEndpoints({
        projects: ["look-and-like"],
        tradename,
      })(locale),
  ];

  const component = i18nFn({
    fetchTranslation: fetchTranslations({ translations }),
    domain: DOMAIN,
  });

  cache.set(tradename, component);
  return component;
};

export { DOMAIN, I18nMessages, PREFIX, i18n };
